<div class="production-db-content" dir="{{languageDir}}">
    <div class="content-top-box">
      <app-bread-crumb></app-bread-crumb>
      <div class="title-row-flex-both-end">
        <h1 class="main-title">{{t('CILDashBoard', 'CIL Dashboard')}}</h1>
      </div>
    </div>
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
    <form [formGroup]="CLLDashboardForm">
        <div class="content-top-row content-top-row-order-processing">
            <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
              <mat-label>{{t('Line', 'Line')}}</mat-label>
              <mat-select formControlName="line" panelClass="testClass" name="line" (selectionChange)="onChangeLine($event)">
                <mat-select-filter [placeholder]="t('Search', 'Search')" [displayMember]="'PL_Desc'" [array]="lineList"
                (filteredReturn)="filteredLines = $event"></mat-select-filter>
                <mat-option  value="0">{{ t('All', 'All') }}</mat-option>
                <mat-option *ngFor="let line of filteredLines" [value]="line.PL_Id">
                  {{line.PL_Desc}}
                </mat-option>
              </mat-select>
            </mat-form-field>
      
            <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
              <mat-label>{{t('Unit', 'Unit')}}</mat-label>
              <mat-select formControlName="unit" panelClass="testClass" name="unit" (selectionChange)="onChangeUnit($event)">
                <mat-select-filter [placeholder]="t('Search', 'Search')" [displayMember]="'PU_Desc'" [array]="unitList"
                (filteredReturn)="filteredUnits = $event"></mat-select-filter>
                <mat-option  value="0">{{ t('All', 'All') }}</mat-option>
                <mat-option *ngFor="let unit of filteredUnits" [value]="unit.PU_Id">
                  {{unit.PU_Desc}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
              <mat-label>{{t('Component', 'Component')}}</mat-label>
                <mat-select formControlName="components" panelClass="testClass" name="Status" (selectionChange)="onSubmit()">
                  <mat-select-filter [placeholder]="t('Search', 'Search')" [displayMember]="'ComponentName'" [array]="componentList"
                  (filteredReturn)="filteredComponents = $event"></mat-select-filter>
                  <mat-option  value="0">{{ t('All', 'All') }}</mat-option>
                  <mat-option *ngFor="let com of filteredComponents" [value]="com.ComponentId">
                    {{com.ComponentName}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </div>
      <!-- Dropdown -->
      <div class="content-top-row content-top-row-order-processing">
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-label>{{t('StartDate', 'Start Date')}}</mat-label>
          <input matInput [ngxMatDatetimePicker]="startPicker" formControlName="dateStart" (dateChange)="onSubmit()"
            [min]="minDate" [max]="maxDate" [disabled]="disabled">
          <mat-datepicker-toggle matSuffix [for]="$any(startPicker)"></mat-datepicker-toggle>
          <ngx-mat-datetime-picker #startPicker [showSpinners]="showSpinners" [showSeconds]="showSeconds"
            [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond" [touchUi]="touchUi" [color]="color"
            [enableMeridian]="enableMeridian">
          </ngx-mat-datetime-picker>
        </mat-form-field>
        <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-label>{{t('EndDate', 'End Date')}}</mat-label>
          <input matInput [ngxMatDatetimePicker]="endPicker" formControlName="dateEnd" (dateChange)="onSubmit()"
            [min]="minDate" [max]="maxDate" [disabled]="disabled">
          <mat-datepicker-toggle matSuffix [for]="$any(endPicker)"></mat-datepicker-toggle>
          <ngx-mat-datetime-picker #endPicker [showSpinners]="showSpinners" [showSeconds]="showSeconds"
            [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond" [touchUi]="touchUi" [color]="color"
            [enableMeridian]="enableMeridian">
          </ngx-mat-datetime-picker>
        </mat-form-field>
        <!-- <div class="btn-position btn-position-order-processing">
          <button mat-flat-button color="accent" class="btn-accent" (click)="onSubmit()">Apply Filter</button>
        </div> -->
        <div class="btn-position">
          <button mat-flat-button color="accent" class="btn-accent" (click)="today()">{{t('Today', 'Today')}}</button>
        </div>
        <div class="btn-position">
          <button mat-flat-button color="accent" class="btn-accent" (click)="yesterday()">{{t('Yesterday', 'Yesterday')}}</button>
        </div>
        <div class="btn-position">
          <button mat-flat-button color="accent" class="btn-accent" (click)="lastWeek()">{{t('LastWeek', 'Last Week')}}</button>
        </div>
        <div class="btn-position">
          <button mat-flat-button color="accent" class="btn-accent" (click)="lastMonth()">{{t('LastMonth', 'Last Month')}}</button>
        </div>
      </div>
      <!-- Card -->
      <div class="menu-card-group">
        <div class="menu-card-item mat-card-height">
          <p class="title-text">{{t('TotalTasksExecution', 'Total Tasks')}}</p>
          <p class="data-text">
            {{TotalDefects}}
            <span class="data-text small-data-text"></span>
          </p>
          <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
            <img class="img" [src]="menuGreenIconUrl" alt="{{ menuGreenIconUrl }}" />
          </div>
        </div>
        <div class="menu-card-item mat-card-height">
          <p class="title-text">{{t('TaskExecuted', 'Tasks Executed')}}</p>
          <p class="data-text">
            {{TotalDefecteSolved}}
            <span class="data-text small-data-text"></span>
          </p>
          <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
            <img class="img" [src]="menuGreenIconUrl" alt="{{ menuGreenIconUrl }}" />
          </div>
        </div>
        <div class="menu-card-item mat-card-height">
          <p class="title-text">{{t('NotExecuted', 'Not Executed')}}</p>
          <p class="data-text">
            {{TotalDefectsPerc}}
            <span class="data-text small-data-text"></span>
          </p>
          <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
            <img class="img" [src]="menuRedIconUrl" alt="{{ menuRedIconUrl }}" />
          </div>
        </div>
        <div class="menu-card-item mat-card-height">
            <p class="title-text">{{t('CILAdherence', 'CIL Adherence')}}</p>
            <p class="data-text">
              {{CILAdherence}}
              <span class="data-text small-data-text"></span>
            </p>
            <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
              <img class="img" [src]="menuRedIconUrl" alt="{{ menuGreenIconUrl }}" />
            </div>
          </div>
      </div>
      <div class="chart-group">
        <div class="chart-items">
          <div class="chart-title">{{t('CILTask', 'CIL Task')}}</div>
          <div [chart]="chartCILTask"></div>
        </div>
        <div class="chart-items">
          <div class="chart-title">{{t('CILTypeChart', 'CIL Type')}}</div>
          <div [chart]="chartCILType"></div>
        </div>
      </div>
      <div class="chart-group">
        <div class="chart-items">
          <div class="chart-title">{{t('CILToolChart', 'CIL Tool')}}</div>
          <div [chart]="chartCILTool"></div>
        </div>
      </div>
    </form>
    <ng-template #imageZoomModel>

      <img [src]="currentImagePath" style="height: 98%; width: 100%; overflow: hidden;">
  
    </ng-template>
    <section>
      <div class="example-button-row">
        <button type="button" class="btn btn-success"  (click)="csvExport()" style="margin-top: 30px;" [pTooltip]="t('ExportCSV', 'Export CSV')" tooltipPosition="top"><img src="assets/images/csv-file-format.png" [alt]="t('ExportCSV', 'Export CSV')"></button>
        <button type="button" class="btn btn-success" (click)="excelExport()" style="margin-top: 30px; margin-left: 10px;" [pTooltip]="t('ExportToExcel', 'Export Excel')" tooltipPosition="top"><i class="fa fa-file-excel-o icon-white"  aria-hidden="true"></i></button>
      </div>
    </section>
    <mat-card-content>
      <ag-grid-angular style="width: 100%; height: 24vw;" class="ag-theme-alpine" [rowData]="rowData"
      [columnDefs]="columnDefs" (gridReady)="onGridReady($event)"  (cellClicked)="cellClicked($event)"
       [gridOptions]="gridOptions" [pagination]="true" [paginationPageSize]="10">
    </ag-grid-angular>
      </mat-card-content>
  </div>